import { render, staticRenderFns } from "./LearningExam.vue?vue&type=template&id=8affc624&scoped=true"
import script from "./LearningExam.vue?vue&type=script&lang=js"
export * from "./LearningExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affc624",
  null
  
)

export default component.exports